export default "__VITE_ASSET__08497a90__"